var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alarm-time-list"},[_c('div',{staticClass:"device-name"},[_vm._v("统计单灯实时报警类型")]),_c('div',{staticClass:"tabList"},[_c('chartsPie',{key:_vm.setRefresh,staticClass:"lampPolice-pie",attrs:{"option":_vm.pieData,"id":"lampPoliceBox"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }